import { IOrderFormFieldPath } from '@app/shared/types';

const ORDER_FORM_FIELD_PATHS: IOrderFormFieldPath = {
  status: 'status',
  vendorName: 'vendor_name',
  vendorEntityId: 'vendor_entity_id',
  siteId: 'site_id',
  siteName: 'site_name',
  storeNumber: 'store_number',
  inventoryItemVenues: 'inventory_items',
  error: 'error',
  itemName: 'item_name',
  itemEntityId: 'item_entity_id',
  glAccountName: 'gl_account_name',
  glAccountEntityId: 'gl_account_entity_id',
  measureId: 'measure_id',
  itemCount: 'count',
  itemCost: 'item_cost',
  initialItemCount: 'initial_count',
  initialItemCost: 'initial_item_cost',
  initialTotalCost: 'initial_total_cost',
  totalCost: 'total_cost',
  orderDate: 'transaction_date',
  deliveryDate: 'delivery_date',
  deliveryFee: 'delivery_fee',
  taxFee: 'tax_fee',
  measureCode: 'measure_code',
  measureEntityId: 'measure_entity_id',
  measureFactorValue: 'measure_factor_value',
  measureDescription: 'measure_description',
  quantityReceived: 'quantity_received',
  receivedUnitCost: 'received_unit_cost',
  receivedTotalCost: 'received_total_cost',
  reportingCategoryMajor: 'reporting_category_major',
  reportingCategoryMinor: 'reporting_category_minor',
  gLAccount: 'gl_account',
  virtualTotalStatus: 'virtual.item_totals',
  virtualTotalCostShow: 'virtual.total_cost_show',
  virtualGrandTotal: 'virtual.grand_total',
  virtualInventoryItemVenues: 'virtual.inventory_items',
  virtualItemList: 'virtual.item_list',
  virtualAddedItemList: 'virtual.added_item_list',
};

export { ORDER_FORM_FIELD_PATHS };
